import React from "react"
import Seo from "../components/seo"
import Layout from "../components/layout"
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"
import { Link } from "gatsby"
import "../styles/pc/page/philosophy.scss"
import "../styles/sp/page/philosophy.scss"

export default function PhilosophyPage() {
  return (
    <Layout>
      <Seo
        type="article"
        title="ジェイフィールの想い"
        description=""
        bobyClassName="menu19"
        path="philosophy"
      />
      <div className="wrapper philosophy">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/philosophy" className="current">Philosophy</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Philosophy</span></h2>
              <p className="subtitle"><span>ジェイフィールの想い</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        <div className="contents contents_wrap" id="mission_ttl">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              <div className="philosophy_cnt_wrap">
                <div className="philosophy_ttl_l">
                  <div className="inner_title fixed mission">
                    <div className="inner_title_in">
                      <h4 className="maintitle sp_vertical border_none"><span>Mission</span></h4>
                      <p className="subtitle pc_only"><span>わたしたちのミッション</span></p>
                    </div>
                  </div>
                </div>
                <div className="philosophy_cnt_r">
                  <div className="cnt_wrap">
                    <p className="read_ttl">人と組織と社会のつながりを再生し、未来へつなぐ</p>
                    <p className="read_bold">
                      ここにいると、違いを越えて、みんながつながる<br />
                      ここにいると、世界が広がり、思いが湧いてくる<br />
                      ここにいると、想いが重なり、踏み出したくなる<br /><br />
                      そんな人たちが、人と組織と社会の壁をなくし<br />
                      互いの未来のために自然につながっていく<br />
                      私たちはそんな世界を皆さんと一緒につくりたい
                    </p>
                    <p className="read">私たちジェイフィールは、2007年の創業時、<br />
                      「今の経営には感情という最後のピースが足りない」<br />
                      「組織の中につながりを再生し、良い感情の連鎖を起こそう」<br />
                      「仕事が面白い、職場が楽しい、会社が好きだということを<br />
                      子どもたちの前で堂々と語れる大人を増やそう」と呼びかけ、<br />
                      そんな思いでつながる人たちを一貫して応援し続けてきました。<br /><br />
                      この思いは今も変わっていません。<br />
                      ただ、ここに来て、人と組織との関係、社会のあり方が変化してきているのではないか。<br />
                      何が変わろうとしているのか、私たちジェイフィールはこれらの変化とどう向き合えばいいのか。<br />
                      そんな対話を繰り返し、各人の思い（本当はこうしたいという考えや気持ち）を重ねて、<br />
                      未来への想い（創り出したい世界のイメージ）を一緒につくっていきました。<br /><br />
                      最初にみんなで対話したのは、働く人たちに起きている変化です。<br />
                      組織を守ることが、自分や家族を守り、社会を守ることになる。<br />
                      そう信じて目の前の仕事を続けてきた人たちも、組織という存在と自分の人生を<br />
                      客観的に捉えるようになり、自分が一番大切にしたいものが何かを悩み始めています。<br />
                      自分らしくイキイキできることが一番大事、家族との時間が一番大事、<br />
                      仲間と楽しく働けることが一番大事、社会や地球の問題と向き合うことが一番大事・・・。<br />
                      組織が最優先の時代が終わり、一人ひとり自分が大切にしたいものを追求する時代。<br />
                      心に押し込めていたものから解き放たれ、人の可能性が拓く時代になるのではないか。<br /><br /><br />
                      一方で、この変化は人にも組織にも新たな困難を突き付けることになるのではないか。<br />
                      居場所を失う、生き方が見えなくなる、働くことの意義を見失う、どこにも行けず立ち止まる・・・。<br />
                      迷う人たちがいても、誰もそこに触れない、対話をしない「無関心な職場」になるかもしれない。<br />
                      多様な人たちがバラバラになる、自分優先の人たちだけの集まりになる、組織の力にならない・・・。<br />
                      組織の中で価値観や思いを重ねることが出来ない「静かなる分断」が生まれてしまうかもしれない。<br /><br />
                      同時に、組織自体のあり方も問われる時代になるのではないかという対話になりました。<br />
                      自己利益だけのために組織が存在するのではなく、社会や地球の課題解決のために組織が<br />
                      存在するという視点で、自分たちの存在価値を再定義することが求められています。<br />
                      組織の存在価値を社会起点で捉え直し、実際にマネジメントの軸も転換しなければ、<br />
                      若い世代から選ばれる会社になれない、社会から選ばれる存在になれない。<br />
                      こんな課題と直面する企業に対して、私たちはどう支援したらいいのだろうか。<br />
                      こうした変化と向き合う対話を重ねる中で、私たちの中に見えてきたこと。<br />
                      それは、人と組織と社会をつなぎ、新たな関係性をつくることが、<br />
                      こうした変化と向き合い、未来を切り拓く大きなカギになるのではないかということでした。<br /><br />
                      自分の意思を押し込めて組織の意思に従うのではなく、<br />
                      互いの意思を重ね合い、組織の意思をともにつくる関係へ。<br />
                      自分だけが幸せになる解決策を互いに主張し合うのではなく、<br />
                      人と組織と社会の問題を一つの問題と捉え、ともに解決していく関係へ。<br />
                      お互いの役割を決め、距離感をとって関わり合わないのではなく、<br />
                      違いや立場を超え、理解し合い、思いを重ね、一緒に探究していく関係へ。<br />
                      人と組織と社会が互いのためにつながる新たな関係性が求められているのだと思います。<br /><br />
                      そのためには、3つの感覚を取り戻すことが重要なのではないかと考えました。<br />
                      人と組織と社会がもともと持っていた「すべてはつながっているという感覚」。<br />
                      押し込めている感覚を解放し、「自然体の自分を出せているという感覚」。<br />
                      そして対話を通じて、「気づくと想いが重なり、みんなで踏み出していく感覚」。<br />
                      この3つの感覚を持てるような機会と場をつくり、対話を重ねるプロセスを創り出すことではないか。<br />
                      「感情とつながり」の再生を一貫して追求してきたジェイフィールだからこそ、応援できることではないか。<br /><br />
                      ここにいると、なぜだが自然に「つながれる」「自分らしくなれる」「想いが重なり、動き出す」。<br />
                      そんなコミュニティ、職場、会社、社会をつくりたい。そんな想いをつなぐプラットフォームになりたい。<br />
                      そして、誰もが笑顔でイキイキと生きていける未来をみんなで一緒につくりたい。<br /><br />
                      これが私たちジェイフィールに集う仲間たちが、対話を重ねてたどり着いた「未来への想い」です。</p>
                  </div>
                </div>
              </div>
            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
        {/*//////////////////////////////* ↓コンテンツ02 * //////////////////////////////*/}
        <div className="contents contents_wrap" id="key_method_ttl">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              <div className="philosophy_cnt_wrap">
                <div className="philosophy_ttl_l">
                  <div className="inner_title fixed method">
                    <div className="inner_title_in">
                      <h4 className="maintitle pc_only"><span>Key Method</span></h4>
                      <p className="subtitle pc_only"><span>大事にしているメソッド</span></p>
                    </div>
                  </div>
                </div>
                <div className="philosophy_cnt_r">
                  <div className="inner_title sp_only">
                    <div className="inner_title_in sp_only">
                      <h4 className="maintitle sp_only"><span>Key Method</span></h4>
                    </div>
                  </div>
                  <div className="cnt_wrap">
                    <div className="flex_wrap step_wrap scroll_x">
                      <div className="flex_contents">
                        <div className="step_box"><Link to="/key-method/connecting-leader"><p>コネクティングリーダー</p><span>未来と世界を結ぶ新たなリーダー</span></Link></div>
                      </div>
                      <div className="flex_contents">
                        <div className="step_box"><Link to="/key-method/organizational-feeling"><p>組織感情</p><span>組織感情をマネジメントする</span></Link></div>
                      </div>
                      <div className="flex_contents">
                        <div className="step_box"><Link to="/key-method/engineering-for-feeling"><p>感情エンジニアリング</p><span>やってみたいという感情を引き出す</span></Link></div>
                      </div>
                      <div className="flex_contents">
                        <div className="step_box"><Link to="/key-method/reflection-and-dialog"><p>内省と対話</p><span>自分を知り、他人を知る</span></Link></div>
                      </div>
                      <div className="flex_contents">
                        <div className="step_box m_btm0"><Link to="/key-method/connection-power"><p>つながり力</p><span>一人ひとりがつながる力</span></Link></div>
                      </div>
                      <div className="flex_contents">
                        <div className="step_box m_btm0"><Link to="/key-method/communityship"><p>コミュニティシップ経営</p><span>みんながリーダー、みんながメンバー</span></Link></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ02 * //////////////////////////////*/}
        {/*//////////////////////////////* ↓コンテンツ03 * //////////////////////////////*/}
        <div className="contents contents_wrap" id="symbol_ttl">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              <div className="philosophy_cnt_wrap">
                <div className="philosophy_ttl_l">
                  <div className="inner_title fixed symbol">
                    <div className="inner_title_in">
                      <h4 className="maintitle sp_vertical border_none"><span>Symbol</span></h4>
                      <p className="subtitle pc_only"><span>ジェイフィールのロゴ</span></p>
                    </div>
                  </div>
                </div>
                <div className="philosophy_cnt_r">
                  <div className="cnt_wrap">
                    <div className="logo_Img"><LazyAndPreloadImage className="pc_only" imgUrl={"../images/corporate_logo.png"} alt={"ジェイフィール ロゴ"} width="703" height="333" /><LazyAndPreloadImage className="sp_only" imgUrl={"../images/corporate_logo_sp.png"} alt={"ジェイフィール ロゴ"} width="334" height="170" /></div>
                    <p className="read">J.Feelのロゴは、日本の生産デザインをリードしてきた岩倉信弥さんに作って頂きました。○は円満、△は革新、□は堅実をイメージさせる形です。<br />
                      この３つの形で表したＪの文字には、次のような我々の想いが込められています。</p>
                  </div>
                  <div className="cnt_wrap">
                    <dl className="philosophy_detail">
                      <dt>日本という国、企業の在り様</dt>
                      <dd>革新は大切です。しかし、それによって人や環境が傷つく社会は世界から尊敬を集めることはできません。焦ることで、大切なものを失うこともあります。革新しつつ、人々や環境の円満と、それを堅実に進めていく腰の据わった国、企業作りを目指していきたいという想いです。</dd>
                    </dl>
                    <dl className="philosophy_detail">
                      <dt>個人の在り様</dt>
                      <dd>組織には色々な人がいます。○の人も、△の人も、□の人も。豊かな組織感情の基本は、こうした多様性の認知だと思います。他の人の色々な特徴を受け入れていく。また、例えば、□の人も、いつも四角四面でいるのではなく、たまには自ら革新にも挑戦し、円満な姿勢で人に接してみる。一人一人のこんな行動が、活気があり、人々の関係性が高い組織を生むという想いです。</dd>
                    </dl>
                    <dl className="philosophy_detail">
                      <dt>我々の会社の在り様</dt>
                      <dd>私たちは感情ルネサンスという、ある意味世の中に対して革新的な活動を行います。と同時に、自分たちのチーム自体が夢があり、楽しく働ける○の形をした組織であることを目指します。そして、この夢を焦ることなく、着実、堅実に一歩一歩追求していくという想いです。</dd>
                    </dl>
                    <p className="annotation">
                      <span>岩倉信弥氏</span><br />
                      多摩美術大学教授。創業者・本田宗一郎の薫陶を受け、幅広いデザイン活動や商品開発に携わる。（株）本田技術研究所専務取締役、本田技研工業（株）常務取締役 (四輪事業本部商品担当)を歴任。初代シビックのデザイン責任者としてCar Of the Yearを受賞。計４度のCar Of the Yearを受賞し、ホンダ４輪の基盤づくりに貢献。全国発明表彰通産大臣賞、イタリアピアモンテデザイングランプリ・グッドデザイン大賞等。
                    </p>
                    <p className="annotation">
                      <span>著書</span><br />
                      「本田宗一郎に一番叱られた男の本田語録」（三笠書房刊）<br />
                      ホンダのデザイン戦略経営（日本経済新聞社）<br />
                      デザイン「こと」始め - ホンダに学ぶ（産能大学出版部）<br />
                      ホンダにみるデザイン・マネジメントの進化（税務経理協会）
                    </p>
                  </div>
                  </div>
                </div>
              </div>{/* padding_sp スマホのみ隙間 */}
            </div>{/* contents_in */}
          </div>{/* /contents */}
          {/*//////////////////////////////* ↑コンテンツ03 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Philosophy - </span><span className="txt">ジェイフィールの想い</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
